export const brandSort = ( a, b ) => {
    if ( a.brand_name < b.brand_name ){
      return -1;
    }
    if ( a.brand_name > b.brand_name ){
      return 1;
    }
    return 0;
}

export const labelSortAlphabetical = ( a, b ) => {
  if ( a.label < b.label ){
    return -1;
  }
  if ( a.label > b.label ){
    return 1;
  }
  return 0;
}